import React, { useEffect } from "react";
import logo from "./assets/logofinal-flat.png";
import "./HomeV2.css";
import "./CompanyPages.css";

const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.akremanaya.weavevomobile&hl=fr";


export function useWeavevoI18n(dictionary) {
  const lang = typeof window !== "undefined"
    ? String(localStorage.getItem("weavevo_lang") || sessionStorage.getItem("weavevo_lang") || "en").toLowerCase()
    : "en";
  const locale = lang.startsWith("fr") ? "fr" : "en";
  return { locale, t: (key) => dictionary?.[locale]?.[key] ?? dictionary?.en?.[key] ?? key };
}

export default function CompanyPageLayout({ pageTitle, title, children }) {
  useEffect(() => {
    document.title = `${pageTitle || title} | Weavevo`;
    window.scrollTo(0, 0);
  }, [pageTitle, title]);

  return (
    <div className="cp-page">
      <header className="hv2-nav hv2-navPersistent cp-header" aria-label="Weavevo navigation">
        <a className="hv2-brand" href="/" aria-label="Weavevo home">
          <img src={logo} alt="Weavevo" />
          <span>weavevo</span>
        </a>
        <nav className="hv2-topMenu hv2-topMenuExpanded" aria-label="Home page sections">
          <a href="/homeV2#product">Product</a>
          <a href="/homeV2#highlights">Features</a>
          <a href="/homeV2#use-cases">Use Cases</a>
          <a href="/homeV2#technology">Technology</a>
          <a href="/homeV2#weavers">Weavers</a>
          <a href="/homeV2#footer-resources">Resources</a>
          <a href="/homeV2#footer-company">Company</a>
          <a className="hv2-headerLoginLink" href="/homeV2#product">Log in</a>
        </nav>
      </header>

      <main className="cp-simpleMain">
        <article className="cp-document">
          <h1 className="cp-simpleTitle">{title}</h1>
          {children}
        </article>
      </main>

      <footer className="hv2-footerV2 hv2-footerV2Mega cp-footer" id="site-footer" aria-label="Weavevo footer">
        <div className="hv2-footerMegaGrid">
          <div className="hv2-footerBrandColumn">
            <a className="hv2-footerBrand" href="/homeV2" aria-label="Weavevo home">
              <img src={logo} alt="" aria-hidden="true" />
              <span>weavevo</span>
            </a>
            <p>
              Living media built from connected human perspectives, intelligent curation and evolving video experiences.
            </p>
            <a className="hv2-footerContact" href="/contact">Contact / Support</a>
          </div>

          <div className="hv2-footerColumn">
            <h4>Product</h4>
            <a href="/homeV2#product">Overview</a>
            <a href="/homeV2#highlights">Features</a>
            <a href="/homeV2#technology">Technology</a>
            <a href="/homeV2#weavers">Weaver Network</a>
          </div>

          <div className="hv2-footerColumn cp-footerExplore">
            <h4>Use Cases</h4>
            <a href="/use-cases/booking">Booking</a>
            <a href="/use-cases/hotel">Hotel</a>
            <a href="/use-cases/real-estate">Real Estate</a>
            <a href="/use-cases/museum">Museum</a>
            <a href="/use-cases/live-events">Live Events</a>
            <a href="/use-cases/sport">Sport</a>
            <a href="/use-cases/media">Media</a>
            <a href="/use-cases/ai-proposal">AI Proposal</a>
            <a href="/use-cases/geolocalisation">Geolocalisation</a>
            <a href="/use-cases/map">Map</a>
            <a href="/use-cases/wizard">Wizard</a>
          </div>

          <div className="hv2-footerColumn" id="footer-resources">
            <h4>Resources</h4>
            <a href="/living-weave-pipeline">Living Weave Pipeline</a>
            <a href="/earning-model">Earning model</a>
            <a href="/homeV2#highlights">AI & Automation</a>
            <a href="/homeV2#weavers">For Weavers</a>
            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer">Google Play</a>
            <a href="/faq">Help & Support</a>
          </div>

          <div className="hv2-footerColumn" id="footer-company">
            <h4>Company</h4>
            <a href="/about">About Weavevo</a>
            <a href="/mentions-legales">Legal notice</a>
            <a href="/politique-confidentialite">Privacy policy</a>
            <a href="/cgu">Terms of use</a>
            <a href="/accessibilite-rgpd">Accessibility & GDPR</a>
          </div>
        </div>

        <div className="hv2-footerBottomLine hv2-footerMegaBottom">
          <span>© 2026 Weavevo. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}
